import { Component, OnInit, OnChanges, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import {ConstantsService, LookupsService, SessionService, AccountService,
   CompaniesEnum, RequestServiceModelView } from '@app/base/core';
import { BuilderService, MeterActivateModel, ServiceActivationRequestModel } from '@app/modules/builder/base';
import { DatePipe } from '@angular/common';
import { SocoHttpService } from '@app/soco/http';
import { phoneNumber, triggerFormValidation, focusFirstInvalidField } from '@app/shared/functions';

const moment = require('moment');
require('moment-weekday-calc');

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'service-activate-request',
  templateUrl: './service.activate.request.component.html',
  styleUrls: ['./service.activate.request.component.css']
})

/// Service Activate request component to implement functions for Meter Activate/ Deactivate Form.
export class ServiceActivateRequestComponent implements OnInit, OnChanges {

 // Global variables to be used across different functions.
  _validateEmail: boolean;
  builderActivationOrDeactivationForm: FormGroup;
  model: MeterActivateModel = new MeterActivateModel();
  userName: string;
  builderactivationOrDeactivation: ServiceActivationRequestModel = new ServiceActivationRequestModel();
  LotStatusId: string;
  flagMail: false;
  _lotData: RequestServiceModelView[];
  public dateOptions: any = {
    alwaysShowCalendars: false,
    singleDatePicker: true,
    autoUpdateInput: true,
    showDropdowns: true,
    parentEl: '.activateDate .col-md-6',
    //CXCO-1892 : Change Requested Date field to allow dates from current day to be selected
    //minDate: moment().addWorkdays(21),
    minDate: moment(),
    isInvalidDate: (date) => (date.day() === 0 || date.day() === 6)
};
  marketer = [];
  cities: any[];
  states = [];
  cityList: any[];
  companiesEnum: typeof CompaniesEnum = CompaniesEnum;
  builderstate: any;
  buildercity: any;
  countylist: any[];

 // Constructor with the variables declared for necessary services to be used across the component.
  constructor(
    private datePipe: DatePipe,
    private fb: FormBuilder,
    public socoHttp: SocoHttpService,
    public lookupSvc: LookupsService,
    public constantsSvc: ConstantsService,
    public sessionSvc: SessionService,
    public builderSvc: BuilderService,
    private accountSvc: AccountService
  ) {

    this.userName = this.accountSvc.account.user.username;

      }

  // ng Onchanges  function to make an api call to with Lot Id and Grid as parmeters
  // if there is data received from the database bind the data to input fields.
  // if no data is present then bind only the builder information available from the services.
  ngOnChanges(): void {
   this.lookupSvc.commonLookupsLoaded$.subscribe(isloaded => {
      if (isloaded && this._lotData !== undefined && this._lotData[0] !== undefined) {
        this.builderActivationOrDeactivationForm.reset();
      this.socoHttp.showPleaseWait('Processing.', 'ContainerAwaiter3');
      this.builderSvc.GetLots(this._lotData[0].grId, this._lotData[0].builderId).subscribe(result2 => {
        const tempList: any = [];
        for (const i of result2.data) {
          if (i.lotNumber === this._lotData[0].lotNumber) {
            tempList.push(i);
          }
        }
        this.builderSvc.getSubsidiaryInfo([tempList[tempList.length - 1].builderId]).subscribe(result => {
          this.sessionSvc.builderData.subscribe(success => {
            if (success  && this.lookupSvc !== undefined && this.lookupSvc.cities !== undefined &&
              this.lookupSvc.states !== undefined && this.lookupSvc.serviceCounty !== undefined) {
                if ( this._lotData[0].stateCd.toUpperCase() === this.companiesEnum.GA) {
                  this.builderActivationOrDeactivationForm.controls['marketerValue'].setValidators(Validators.required);
                } else {
                  this.builderActivationOrDeactivationForm.controls['marketerValue'].clearValidators();
                }
              if (success.CompanyAddress.state != null) {
                this.builderstate = this.lookupSvc.states.find(x => x.id === result.data[0].builderAddresses.state ).itemName;
              }
              if (success.CompanyAddress.city != null ) {
                this.buildercity = this.lookupSvc.cities.find(x => String(x.id) === result.data[0].builderAddresses.city ).itemName;
              }
              if (this.lookupSvc.serviceCounty !== undefined) {
              this.countylist = this.lookupSvc.serviceCounty;
              }
              this._lotData[0].city = this._lotData[0].city.replace(/,/g, '');
              this.builderActivationOrDeactivationForm.patchValue({
                  firstName: this.accountSvc.account.user.username, // success.AdminUsers['firstName'],
                  lastName: this.accountSvc.account.user.username, // success.AdminUsers['lastName'],
                  buildercity: result.data[0].builderAddresses.city != null ?
                   this.lookupSvc.cities.find(a => String(a.id) === result.data[0].builderAddresses.city).itemName : null,
                   builderstate: result.data[0].builderAddresses.state != null ?
                  this.lookupSvc.states.find(a => a.id === result.data[0].builderAddresses.state).itemName : null,
                  builderzipCode: result.data[0].builderAddresses.zipCode,
                  subdivision : this._lotData[0].subDivision,
                  builderCompanyName: result.data[0].companyName,
                  email: result.data[0].email,
                  streetNumber: this._lotData[0].streetNo,
                  adjoinStreetName: this._lotData[0].streetName,
                  builderstreetAddress: result.data[0].builderAddresses.address2,
                  contactPhoneNumberExtension: result.data[0].builderAddresses.contactName1Extn,
                  contactPhoneNumber: result.data[0].builderAddresses.contactName1Phone,
                  alterPhoneNumberExtension: result.data[0].builderAddresses.contactName2Extn,
                  alternatePhoneNumber: result.data[0].builderAddresses.contactName2Phone,
                  unitNumber: this._lotData[0].unitNo,
                  city: this.lookupSvc.cities.find(a => a.itemName.toUpperCase() === this._lotData[0].city.toUpperCase()),
                  state: this.lookupSvc.states.find(a => a.id.toUpperCase() === this._lotData[0].stateCd.toUpperCase()),
                  zipCode: this._lotData[0].zip,
                  county: this.countylist.find(a => a.id === this._lotData[0].countyId) !== null ?
                   this.countylist.find(a => a.id === this._lotData[0].countyId) : null,
                  directionPrefix: this.lookupSvc.directions.find(a => a.id === this._lotData[0].applicantDirectionPrefix) !== null ?
                  this.lookupSvc.directions.find(a => a.id === this._lotData[0].applicantDirectionPrefix) : null,
                  lotNumber: this._lotData[0].lotNumber
                });
              }
          });
        });
      });
      /// Api call to the database to check if a record exists with the lot number and Gr Id.
      this.builderSvc.getMeterInfo(this._lotData[0].lotNumber.toString(), this._lotData[0].grId.toString()).subscribe(result => {
        if (result.data != null) {
          const meterData = result.data;
          //CXCO-1892 : Change to fetch the meter number from BLDR_LOT_ACTIVATE table when it is not null
          if (meterData['meterNum'] != ''){
            this.builderActivationOrDeactivationForm.patchValue({
              gasMeterNumber: meterData['meterNum']
            });
          }
          //CXCO-1892 : Fetch the meter number from WORKREQUEST_VIEW when its null in BLDR_LOT_ACTIVATE table
          else{
            this.builderActivationOrDeactivationForm.patchValue({
              gasMeterNumber: this._lotData[0].meterNumber
            });
          }
          this.builderActivationOrDeactivationForm.patchValue({
            //gasMeterNumber: meterData['meterNum'],
            meter: meterData['turnOn'] === 'Y' ? 'On' : 'Off',
            requestedDate: this.datePipe.transform(meterData['requestedDate'], 'MM/dd/yy'),
            emailAddress: meterData['email'],
            reEnterEmailAddress: meterData['email'],
            isCornorLot: meterData['cornerLotNo'],
            adjoinStreetName: meterData['adjoinStreetName'],
            streetNameThoroughfar: meterData['streNameThroughFare'],
            specialNotes: meterData['comments'] !== null ? meterData['comments'] : null,
            marketerValue: this.lookupSvc.MarketerOfChoice.find(a => a.id === meterData['marketerId'] ),
            closeMainIntrStr: meterData['closestMainInterSectStr'],
          });
          this.socoHttp.hidePleaseWait('ContainerAwaiter3');
        } else {
          this.builderActivationOrDeactivationForm.patchValue({
            gasMeterNumber: this._lotData[0].meterNumber
          });
          this.socoHttp.hidePleaseWait('ContainerAwaiter3');
        }
      });
    }
  });
  if (this.close === true) {
    this.reset();
  }
}

  // The initialization of the  Form Group, which includes the disabled fields and validations.
  ngOnInit() {
    this.cityList = this.lookupSvc.cities;
    this.marketer = this.lookupSvc.MarketerOfChoice;

    this.builderActivationOrDeactivationForm = this.fb.group(
      {
        'gasMeterNumber': [this.builderactivationOrDeactivation.gasMeterNumber, [Validators.pattern(this.constantsSvc.numericPattern)]],
        'subdivision': [this.builderactivationOrDeactivation.subdivision],
        'meter': [this.builderactivationOrDeactivation.meter, [Validators.required]],
        'requestedDate': [this.datePipe.transform(this.builderactivationOrDeactivation.requestedDate, 'MM/dd/yyyy'), Validators.required],
        'emailAddress': [this.builderactivationOrDeactivation.emailAddress, Validators.pattern(this.constantsSvc.emailPattern)],
        'reEnterEmailAddress': [this.builderactivationOrDeactivation.reEnterEmailAddress,
          Validators.pattern(this.constantsSvc.emailPattern)],
        'builderCompanyName': [{value : this.builderactivationOrDeactivation.builderCompanyName, disabled: true}],
        'contactName': [{value : null, disabled: true}],
        'streetNumber': [this.builderactivationOrDeactivation.streetNumber, [ Validators.required,
          Validators.pattern(this.constantsSvc.numericPatternwithZero)]],
        'streetNameThoroughfar': [this.builderactivationOrDeactivation.streetNameThoroughfar],
        'isCornorLot': [this.builderactivationOrDeactivation.meter, Validators.required],
        'adjoinStreetName': [this.builderactivationOrDeactivation.adjoinStreetName],
        'unitNumber': [null, Validators.pattern(this.constantsSvc.alphaNumericPattern)],
        'city': [{value: null, disabled: true}],
        'state': [{ value: null, disabled: true }],
        'closeMainIntrStr': [null],
        'zipCode': [{ value: null, disabled: true }],
        'contactPhoneNumber': [{value: this.builderactivationOrDeactivation.contactPhoneNumber, disabled: true},
          [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]],
        'contactPhoneNumberExtension': [{value: this.builderactivationOrDeactivation.contactPhoneNumberExtension,
        disabled: true}, Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern)],
        'alternatePhoneNumber': [{value: this.builderactivationOrDeactivation.alternatePhoneNumber, disabled: true},
          [Validators.required, Validators.pattern(this.constantsSvc.phoneNumberPattern)]],
        'alternatePhoneNumberExtension': [{value: this.builderactivationOrDeactivation.alternatePhoneNumberExtension,
          disabled: true}, Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern)],
        'marketerValue': [this.builderactivationOrDeactivation.marketerValue],
        'builderstreetAddress': [{value: this.builderactivationOrDeactivation.streetAddress, disabled: true}],
        'builderstate': [{value: this.builderactivationOrDeactivation.state, disabled: true}],
        'buildercity': [{value: this.builderactivationOrDeactivation.city, disabled: true}],
        'builderzipCode': [{value: this.builderactivationOrDeactivation.zipCode, disabled: true}],
        'directionPrefix': [null],
        'specialNotes': [null],
        'lotNumber':  [{value: null, disabled: true}],
        'county':  [{value: null, disabled: true}]
      }
    );
  }


  // Service activate request component grid event is emitted to paremt service request to refresh grid.
  @Output() updateGrid = new EventEmitter<any>();

  // Input components to store  Grid event row data.
  @Input() set lotdata(data: RequestServiceModelView[]) {
    this._lotData = data;
    }

  @Input() close;
   get  lotdata() {
     return this._lotData;
   }


  // On Submit event If the form is valid call the submitMeter request Function.
  // else swal alert to show the user to fill in the valid details.
  OnSubmit() {
    if (this.builderActivationOrDeactivationForm.valid && !this._validateEmail) {
      this.submitMeterRequest(this.builderActivationOrDeactivationForm.value);
    } else  {
      triggerFormValidation(this.builderActivationOrDeactivationForm);
      focusFirstInvalidField(this.builderActivationOrDeactivationForm);
    }
  }

  // On Submit event to assign the data to requestservice and meterActivation model
  private submitMeterRequest(fg: ServiceActivationRequestModel): void {
    const lotSubmitData = this._lotData[0];
    if ((lotSubmitData.lotStatus === this.constantsSvc.activationRequested ||
      lotSubmitData.lotStatus === this.constantsSvc.activationApproved)
    && fg.meter === 'On') {
      if (lotSubmitData.lotStatus === this.constantsSvc.activationRequested) {
        const msg = this.constantsSvc.activateSubmitted;
        swal(this.constantsSvc.errorSwal1, msg, this.constantsSvc.errorSwal);
      } else {
        const msg = this.constantsSvc.activateApproved;
        swal(this.constantsSvc.errorSwal1, msg, this.constantsSvc.errorSwal);
      }

      $('#modal_activate_deactivate').modal('hide');
    } else if ((lotSubmitData.lotStatus === this.constantsSvc.deactivationRequested
      || lotSubmitData.lotStatus === this.constantsSvc.deactivationApproved)
  && fg.meter !== 'On') {
      if (lotSubmitData.lotStatus === this.constantsSvc.deactivationRequested) {
        const msg = this.constantsSvc.deactivateSubmitted;
      swal(this.constantsSvc.errorSwal1, msg, this.constantsSvc.errorSwal);
      } else {
        const msg = this.constantsSvc.deactivationApproved;
      swal(this.constantsSvc.errorSwal1, msg, this.constantsSvc.errorSwal);
    }

    $('#modal_activate_deactivate').modal('hide');
  } else {
    // Assigning the data realted to Meter Acitvation Table
    this.model.id = this._lotData[0].lotNumber;
    this.model.grId = this._lotData[0].grId.toString();
    this.model.meterNum = fg.gasMeterNumber;
    this.model.turnOn = fg.meter === 'On' ? 'Y' : 'N';
    this.model.requestedDate = fg.requestedDate;
    this.model.email = fg.emailAddress;
    this.model.cornerLotNo = fg.isCornorLot;
    this.model.adjoinStreetName = fg.adjoinStreetName;
    this.model.recCreatedBy = this._lotData[0].builderId;
    this.model.recCreatedDTTM =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    this.model.builderId = this._lotData[0].builderId;
    this.model.closestMainInterSectStr = fg.closeMainIntrStr;
    this.model.comments = fg.specialNotes;
    this.model.streNameThroughFare = fg.streetNameThoroughfar;
    if (fg.marketerValue !== null && fg.marketerValue !== undefined) {
    this.model.marketerId = fg.marketerValue !== null ? fg.marketerValue['id'] : null;
    }
    // Assigning data related to Gas WR summary table
    lotSubmitData.unitNo = this.builderActivationOrDeactivationForm.controls['unitNumber'].value;
    lotSubmitData.subDivision = this.builderActivationOrDeactivationForm.controls['subdivision'].value;
    lotSubmitData.lotStatus = fg.meter === 'On' ? 'ACR' : 'DR';
    lotSubmitData.streetNo = this.builderActivationOrDeactivationForm.controls['streetNumber'].value;
    lotSubmitData.lotStatusUpdatedBy = this.userName;
    lotSubmitData.lotStatusUpdatedDate =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    lotSubmitData.recUpdateDttm =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
    lotSubmitData.recUpdateUsrId = this.userName;
    if (this.builderActivationOrDeactivationForm.controls['directionPrefix'].value !== null
    && this.builderActivationOrDeactivationForm.controls['directionPrefix'].value !== undefined) {
    lotSubmitData.applicantDirectionPrefix = this.builderActivationOrDeactivationForm.controls['directionPrefix'].value['id'];
    }
        this.builderSvc.addMeter(this.model, lotSubmitData).subscribe(result => {
      if (result.status) {
        swal(this.constantsSvc.meterActDeactSwal, '', this.constantsSvc.successSwal);
        this.socoHttp.hidePleaseWait('ContainerAwaiter3');
        this.reset();
        $('#modal_activate_deactivate').modal('hide');
        this.updateGridData();
      }
    }, result => {
      if (this.socoHttp.isInvalidResult(result)) {
        swal(this.constantsSvc.errorSwal1, result, this.constantsSvc.failedSwal);
      }
    });

  }
  }

  // Validation for email and confirm email. Copmare the email and reEnter email and if the value is same
 // set the variable _validateEmail to false, Else set the _validateEmail to true.
  validateEmail() {
    const email = this.builderActivationOrDeactivationForm.controls['emailAddress'].value;
    const reEnterMail = this.builderActivationOrDeactivationForm.controls['reEnterEmailAddress'].value;
    if (email !== null && reEnterMail !== null) {
      if (email === reEnterMail) {
        this._validateEmail = false;
        return {reEnterEmailAddress: {validateEmail: false} };

      } else {
        this.builderActivationOrDeactivationForm.controls['reEnterEmailAddress'].setErrors({validateEmail : true});
        this._validateEmail = true;
      }
    }
  }

  // Reset event to reset the form controls and boolean of _validate email on close of the component.
  reset() {
    this._validateEmail = false;
    this.builderActivationOrDeactivationForm.reset();
    this.builderActivationOrDeactivationForm.updateValueAndValidity();
  }

  // Update grid event  to emit the boolean value to the parent component to refresh the grid.
  updateGridData() {
    this.updateGrid.emit('true');
  }

  // On click of cancel event to refresh the parent grid component of service requet.
  OnClose() {
    this.updateGridData();
    this.reset();
  }
// Reset event button to reset the non disabled fields.
  Fieldreset() {
    this._validateEmail = false;
 this.builderActivationOrDeactivationForm.controls['gasMeterNumber'].reset();
 this.builderActivationOrDeactivationForm.controls['subdivision'].reset();
 this.builderActivationOrDeactivationForm.controls['meter'].reset();
 this.builderActivationOrDeactivationForm.controls['requestedDate'].reset();
 this.builderActivationOrDeactivationForm.controls['emailAddress'].reset();
 this.builderActivationOrDeactivationForm.controls['reEnterEmailAddress'].reset();
 this.builderActivationOrDeactivationForm.controls['streetNumber'].reset();
 this.builderActivationOrDeactivationForm.controls['streetNameThoroughfar'].reset();
 this.builderActivationOrDeactivationForm.controls['isCornorLot'].reset();
 this.builderActivationOrDeactivationForm.controls['adjoinStreetName'].reset();
 this.builderActivationOrDeactivationForm.controls['marketerValue'].reset();
 this.builderActivationOrDeactivationForm.controls['specialNotes'].reset();
 this.builderActivationOrDeactivationForm.controls['directionPrefix'].reset();
 this.builderActivationOrDeactivationForm.controls['unitNumber'].reset();
 this.builderActivationOrDeactivationForm.controls['closeMainIntrStr'].reset();
  }
}


